/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { BootstrapDialog } from '../../../../assets/style/globalStyle';
import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography
} from '@mui/material';
import { NotificationManager } from 'react-notifications';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import configAxios from '../../../../services/configAxios';
import Iconify from '../../../../@core/theme/Iconify';

const AddEditDayTerm = (props) => {
  const [infosDayTerm, setInfosDayTerm] = useState([]);

  function HandleInputChange(event, autocomplete) {
    if (autocomplete) {
      if (event) {
        setInfosDayTerm({
          ...infosDayTerm,
          [event.target.name]: event.target.value
        });
        return;
      }
      return;
    }
    setInfosDayTerm({ ...infosDayTerm, [event.target.name]: event.target.value });
  }

  function HandleSubmit(event) {
    event.preventDefault();
    infosDayTerm.id_term = props.otherInfos.id;
    infosDayTerm.dia = infosDayTerm.dia.padStart(2, '0');
    infosDayTerm.dia_corte = infosDayTerm.dia_corte.padStart(2, '0');
    configAxios
      .post('/terms/addDayOfTerm', { ...infosDayTerm })
      .then(() => {
        props.setOpenModal(false);
        props.functionGrid();
        setInfosDayTerm({});
        NotificationManager.success('Dia incluído com sucesso!', 'Sucesso');
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para incluir o dia! Tente novamente!',
          'Atenção'
        );
      });
  }

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };
  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };
  return (
    <>
      <div>
        <BootstrapDialog
          onClose={() => {
            props.setOpenModal(false);
            props.functionGrid();
          }}
          aria-labelledby="customized-dialog-title"
          fullWidth
          maxWidth={'md'}
          open={props.openModal}>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => {
              props.setOpenModal(false);
              props.functionGrid();
              setInfosDayTerm({});
            }}>
            Incluir dia de vigência e corte
          </BootstrapDialogTitle>
          <form onSubmit={HandleSubmit}>
            <DialogContent dividers>
              <CustomGrid>
                <Grid item xs={12} sx={{ mt: -1 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    Insira o dia de vigência abaixo e escolha o dia de corte (limite para inclusão)
                  </Typography>
                </Grid>
                <CustomInfosForm sx={{ fontSize: '12px' }}>
                  Campos obrigatórios possuem asterisco (*)
                </CustomInfosForm>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={12} md={3}>
                    <TextField
                      name="dia"
                      fullWidth
                      label="Dia de vigência"
                      variant="outlined"
                      size="small"
                      type="number"
                      required
                      value={infosDayTerm.dia || ''}
                      onChange={(event) => HandleInputChange(event)}
                      inputProps={{ maxLength: 2 }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      name="dia_corte"
                      fullWidth
                      label="Dia de corte"
                      variant="outlined"
                      size="small"
                      type="number"
                      required
                      value={infosDayTerm.dia_corte || ''}
                      onChange={(event) => HandleInputChange(event)}
                      inputProps={{ maxLength: 2 }}
                    />
                  </Grid>
                </Grid>
              </CustomGrid>
            </DialogContent>
            <DialogActions>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                color="success"
                startIcon={<Iconify icon="eva:save-fill" />}>
                Salvar
              </Button>
              <Button
                onClick={() => {
                  props.setOpenModal(false);
                  props.functionGrid();
                  setInfosDayTerm({});
                }}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="eva:close-circle-fill" />}>
                Cancelar
              </Button>
            </DialogActions>
          </form>
        </BootstrapDialog>
      </div>
    </>
  );
};

export default AddEditDayTerm;
